import ConditionPage from '../components/ConditionPage';
import { CONDITIONS_DATA } from '../data/conditions';
export default function PostSurgery() {
  return <ConditionPage data={CONDITIONS_DATA.postSurgery} />;
}
